if (!customElements.get('nm-tabs')) {
  customElements.define(
    'nm-tabs',
    class NmTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        if (typeof Shopify !== 'undefined' && Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            const panel = event.target.closest('[role="tabpanel"]');
            const index = this.panels.indexOf(panel);
            if (index !== -1) this.select(index);
          });
        }
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
          tab.tabIndex = i === index ? 0 : -1;
        });
        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });
      }

      onKeydown(event, index) {
        let target;
        if (event.key === 'ArrowRight') target = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') target = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.select(target);
        this.tabs[target].focus();
      }
    }
  );
}
